import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateStaffingAgencyPocByIdMutation, MutateStaffingAgencyPocByIdMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'
// import { staffingAgencyPocCreatedUpdatedByIdDocument } from '../useStaffingAgencyPocCreatedUpdatedById'

const document = graphql(/* graphql */`
  mutation mutateStaffingAgencyPocById($id: MongoID!, $record: UpdateByIdStaffingAgencyPocInput!) {
    cat {
      staffingAgencyPoc {
        updateById(_id: $id, record: $record) {
          recordId
        }
      }
    }
  }
`)

export type UseMutateStaffingAgencyPocByIdReturn = UseMutationResult<
MutateStaffingAgencyPocByIdMutation,
unknown,
MutateStaffingAgencyPocByIdMutationVariables
>

const useMutateStaffingAgencyPocById = (): UseMutateStaffingAgencyPocByIdReturn => {
  // const invalidateCreatedUpdated = useInvalidateQueryByDocument(staffingAgencyPocCreatedUpdatedByIdDocument)
  return useGraphMutation(document, {
    onSuccess: (data) => {
      const id = data.cat?.staffingAgencyPoc?.updateById?.recordId
      if (typeof id === 'string') {
        // void invalidateCreatedUpdated({ id })
      }
    }
  })
}

export { useMutateStaffingAgencyPocById, document as mutateStaffingAgencyPocByIdDocument }
